import { navigationRef, RnRouterService } from '@tw/tw-runtime-rn';

export class RouteService extends RnRouterService {
  async back(): Promise<void> {
    const states = navigationRef.current?.getRootState();
    return await super.back();
  }
}
